import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../lib/api';
import { useAuth } from '../context/AuthContext';

// Handles the return trip from Emergent-managed Google Auth.
// The user lands here at {origin}/dashboard#session_id=... — we exchange the
// session_id on the backend, store the app JWT, then continue to the dashboard.
const AuthCallback = () => {
  const nav = useNavigate();
  const { applySession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const match = (window.location.hash || '').match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) { nav('/login', { replace: true }); return; }
      try {
        const { token, user } = await authAPI.googleSession(sessionId);
        applySession(token, user);
        // Clear the session_id from the URL so it is used only once.
        window.history.replaceState(null, '', window.location.pathname);
        nav('/dashboard', { replace: true });
      } catch {
        window.history.replaceState(null, '', window.location.pathname);
        nav('/login?error=google', { replace: true });
      }
    })();
  }, [nav, applySession]);

  return (
    <div className="min-h-screen bg-[#050807] flex items-center justify-center text-[#00e676] text-sm" data-testid="auth-callback">
      Signing you in…
    </div>
  );
};

export default AuthCallback;
